import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TipoPagamentoEditarComponent } from './tipo-pagamento-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: TipoPagamentoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class TipoPagamentoEditarRoutingModule { }
